import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/utils/utils";
import {
    LayoutDashboard,
    Users,
    Calculator,
    BarChart3,
    FileText,
} from "lucide-react";

const navItems = [
    { to: "/dashboard", icon: LayoutDashboard, label: "Главная" },
    { to: "/people", icon: Users, label: "Клиенты" },
    { to: "/calculator", icon: Calculator, label: "Расчёт" },
    { to: "/analytics", icon: BarChart3, label: "Аналитика" },
    { to: "/settings", icon: FileText, label: "Настройки" },
];

export function MobileNav() {
    const location = useLocation();

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border md:hidden safe-area-bottom">
            <div className="flex items-center justify-around py-2 pb-safe">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.to;
                    const Icon = item.icon;

                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={cn(
                                "flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-colors min-w-[60px]",
                                isActive
                                    ? "text-foreground"
                                    : "text-muted-foreground"
                            )}
                        >
                            <Icon className={cn("h-5 w-5", isActive && "text-primary")} />
                            <span className="text-xs font-medium">{item.label}</span>
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}
